<script lang="ts">
interface Props {
  imageSrc: string
  imageAlt: string
  imageClass?: string
  category?: string
  title: string
  description: string
  href: string
  buttonText?: string
  /** ISO 8601 date — when provided, renders a visible "Updated" byline. */
  updatedDate?: string
}

let {
  imageSrc,
  imageAlt,
  imageClass = 'image-7',
  category,
  title,
  description,
  href,
  buttonText = 'Read Story',
  updatedDate,
}: Props = $props()

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}
</script>

<div class="case-studies---card">
  <div class="image-wrapper-5">
    <img width="680" height="380" alt={imageAlt} src={imageSrc} loading="lazy" class={imageClass} />
  </div>
  {#if category}<div><strong class="grid-item-value">{category}</strong></div>{/if}
  <div class="grid-item-title"><a {href}><strong>{title}</strong></a></div>
  {#if updatedDate}
    <p class="page-byline">
      Updated <time datetime={updatedDate}>{formatDate(updatedDate)}</time>
    </p>
  {/if}
  <div class="card-info">
    <div class="card-description-wrapper">
      <div class="grid-body-text">{description}</div>
    </div>
  </div>
  <div class="news-card-info">
    <a {href} class="btn-md-tertiary w-inline-block">
      <div class="btn-md-tertiary-textwrap">
        <div class="btn-md-tertiary-text">{buttonText}</div>
      </div>
      <div class="btn-md-tertiary-icon w-embed">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.285 3.6965L7 3L12 8L7 13L6.285 12.2865L10.075 8.5H3V7.5H10.075L6.285 3.6965Z"
          ></path>
        </svg>
      </div>
    </a>
  </div>
</div>

<style>
.grid-item-title a {
  color: inherit;
  text-decoration: none;
}
.grid-item-title a:hover {
  text-decoration: underline;
}
</style>
